const AUTO_CLICKERS = [
  {
    name: "🍭 Starter's click",
    unlockCost: 0.5,
    incomeBaseline: 1,
    incomeMultiplier: 1.3,
    automateCost: 10,
    costBaseline: 3,
    costMultiplier: 1.3,
    waitTime: 1
  },
  {
    name: "🔧 Little click",
    unlockCost: 20,
    incomeBaseline: 10,
    incomeMultiplier: 1.3,
    automateCost: 100,
    costBaseline: 5,
    costMultiplier: 1.3,
    waitTime: 3
  },
  {
    name: "🦛 Big click",
    unlockCost: 50,
    incomeBaseline: 250,
    incomeMultiplier: 1.3,
    automateCost: 500,
    costBaseline: 50,
    costMultiplier: 1.4,
    waitTime: 15
  },
  {
    name: "🗻 World ender",
    unlockCost: 1000000,
    incomeBaseline: 1000,
    incomeMultiplier: 1.3,
    automateCost: 10000000,
    costBaseline: 1000999,
    costMultiplier: 1.7,
    waitTime: 60
  }
];

export default AUTO_CLICKERS;



// WEBPACK FOOTER //
// ./src/auto-clicker-data.js